var amoeba = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/amoeba_gwd.jpg';
var amoebaDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/amoeba_gwdDetail1.jpg';
var bridge = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/bridge_gwd.jpg';
var crescent = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/crescent_gwd.jpg';
var echoII = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/echoII_gwd.jpg';
var ellipse = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/ellipse_gwd.jpg';
var ellipseDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/ellipse_gwdDetail1.jpg';
var lasso = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/lasso_gwd.jpg';
var lassoGld = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/lasso_gld.jpg';
var link = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/link_gwd.jpg';
var loop = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/loop_gd.jpg';
var loopDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/loop_gdDetail1.jpg';
var lunge = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/lunge_gwd.jpg';
var precipice = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/precipice_gwd.jpg';
var ring = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/ring_gwd.jpg';
var spots = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/spots_gwd.jpg';
var suspension = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/suspension_gwd.jpg';
var tetheredLith = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/tethered_lith.jpg';
var tilt = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/tilt_gwd.jpg';
var tiltLd = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/tilt_ld.jpg';
var totem = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/totem_gwd.jpg';
var totemDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/totem_gwdDetail1.jpg';
var wings = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-p/wings_gwd.jpg';

export const allImagesDesktopOrderPaperPools = [
    [/*COLUMN 1*/
        [
            {
                name: spots,
                artistName: "Lorraine Shemesh",
                title: "Spots",
                year: "2011",
                dimensions: "24 1/4 x 24 1/4 in., graphite wash on mylar",
                link: "paperpool1",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: bridge,
                artistName: "Lorraine Shemesh",
                title: "Bridge",
                year: "2011",
                dimensions: "22 x 37 in., graphite wash on mylar",
                link: "paperpool2",
                privateCollection: ""
            }
        ],
        [
            {
                name: tilt,
                artistName: "Lorraine Shemesh",
                title: "Tilt",
                year: "2015",
                dimensions: "21 3/4 x 23 in., graphite wash on mylar",
                link: "paperpool3",
                privateCollection: ""
            },
            {
                name: tiltLd,
                artistName: "Lorraine Shemesh",
                title: "Tilt",
                year: "2015",
                dimensions: "6 x 6 3/4 in., graphite on mylar",
                link: "paperpool4",
                privateCollection: "Private Collection"
            }
        ],
        [
            {   
                name: lunge,
                artistName: "Lorraine Shemesh",
                title: "Lunge",
                year: "2013",
                dimensions: "29 1/2 x 23 in., graphite wash on mylar",
                link: "paperpool5",
                privateCollection: ""
            }
        ],
        [
            {
                name: totem,
                artistName: "Lorraine Shemesh",
                title: "Totem",
                year: "2014",
                dimensions: "32 3/4 x 22 in., graphite wash on mylar",
                link: "paperpool6",
                privateCollection: "Private Collection"
            },
            {
                name: totemDetail1,
                artistName: "Lorraine Shemesh",
                title: "Totem- detail",
                year: "2014",
                dimensions: "32 3/4 x 22 in., graphite wash on mylar",
                link: "paperpool7",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: tetheredLith,
                artistName: "Lorraine Shemesh",
                title: "Tethered",
                year: "2016",
                dimensions: "20 x 22 1/2 in., 2 color lithograph",
                link: "paperpool8",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {    
                name: loop,
                artistName: "Lorraine Shemesh",
                title: "Loop",
                year: "1999-2005",
                dimensions: "24 1/2 x 37 1/2 in., graphite wash on mylar",
                link: "paperpool11",
                privateCollection: "Private Collection"
            },
            {
                name: loopDetail1,
                artistName: "Lorraine Shemesh",
                title: "Loop - detail",
                year: "1999-2005",
                dimensions: "24 1/2 x 37 1/2 in., graphite wash on mylar",
                link: "paperpool12",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: echoII,
                artistName: "Lorraine Shemesh",
                title: "Echo II",
                year: "2005",
                dimensions: "27 1/2 x 28 in., graphite wash on mylar",
                link: "paperpool13",
                privateCollection: ""
            }
        ],
        [
            {
                name: wings,
                artistName: "Lorraine Shemesh",
                title: "Wings",
                year: "2008",
                dimensions: "26 3/4 x 25 1/2 in., graphite wash on mylar",
                link: "paperpool20",
                privateCollection: ""
            }
        ],
        [
            {
                name: lasso,
                artistName: "Lorraine Shemesh",
                title: "Lasso",
                year: "2000",
                dimensions: "32 x 21 1/4 in., graphite wash on mylar",
                link: "paperpool16",
                privateCollection: ""
            },
            {
                name: lassoGld,
                artistName: "Lorraine Shemesh", 
                title: "Lasso",
                year: "2000",
                dimensions: "16 x 10 1/2 in., graphite on mylar",
                link: "paperpool17",
                privateCollection: ""
            }
        ],
        [
            {
                name: ellipse,
                artistName: "Lorraine Shemesh",
                title: "Ellipse",
                year: "1998-2004",
                dimensions: "32 x 18 in., graphite wash on mylar",
                link: "paperpool18",
                privateCollection: "Private Collection"
            },
            {
                name: ellipseDetail1,
                artistName: "Lorraine Shemesh", 
                title: "Ellipse - detail",
                year: "1998-2004",
                dimensions: "32 x 18 in., graphite wash on mylar",
                link: "paperpool19",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: amoeba,
                artistName: "Lorraine Shemesh",
                title: "Amoeba",
                year: "2005",
                dimensions: "31 1/2 x 26 1/2 in., graphite wash on mylar",
                link: "paperpool14",
                privateCollection: "Collection of Marie-Josee Kravis, President Emeritus, MOMA"
            },
            {
                name: amoebaDetail1,
                artistName: "Lorraine Shemesh",
                title: "Amoeba- detail",
                year: "2005",
                dimensions: "31 1/2 x 26 1/2 in., graphite wash on mylar",
                link: "paperpool15",
                privateCollection: "Collection of Marie-Josee Kravis, President Emeritus, MOMA"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: ring,
                artistName: "Lorraine Shemesh",
                title: "Ring",
                year: "1997-2004",
                dimensions: "33 1/2 x 25 1/2 in., graphite wash on mylar",
                link: "paperpool21",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: link,
                artistName: "Lorraine Shemesh",
                title: "Link",
                year: "1999",
                dimensions: "21 3/4 x 21 3/4 in., graphite wash on mylar",
                link: "paperpool22",
                privateCollection: "Collection of The Butler Institute of American Art"
            }
        ],
        [
            {
                name: precipice,
                artistName: "Lorraine Shemesh",
                title: "Precipice",
                year: "2017",
                dimensions: "30 1/4 x 22 in., graphite wash on mylar",
                link: "paperpool23",
                privateCollection: ""
            }
        ],
        [
            {
                name: suspension,
                artistName: "Lorraine Shemesh",
                title: "Suspension",
                year: "2013",
                dimensions: "28 1/2 x 23 in., graphite wash on mylar",
                link: "paperpool24",
                privateCollection: ""
            }
        ],
        [
            {
                name: crescent,
                artistName: "Lorraine Shemesh",
                title: "Crescent",
                year: "2013",
                dimensions: "35 x 22 3/4 in., graphite wash on mylar",
                link: "paperpool25",
                privateCollection: ""
            }
        ]
    ]          
]

export const allImagesMobileOrderPaperPools = [
    [{
        name: spots,
        artistName: "Lorraine Shemesh",
        title: "Spots",
        year: "2011",
        dimensions: "24 1/4 x 24 1/4 in., graphite wash on mylar",
        link: "paperpool1",
        privateCollection: "Private Collection"
    },
    {
        name: bridge,
        artistName: "Lorraine Shemesh",
        title: "Bridge",
        year: "2011",
        dimensions: "22 x 37 in., graphite wash on mylar",
        link: "paperpool2",
        privateCollection: ""
    },
    {
        name: tilt,
        artistName: "Lorraine Shemesh",
        title: "Tilt",
        year: "2015",
        dimensions: "21 3/4 x 23 in., graphite wash on mylar",
        link: "paperpool3",
        privateCollection: ""
    },
    {
        name: tiltLd,
        artistName: "Lorraine Shemesh",
        title: "Tilt",
        year: "2015",
        dimensions: "6 x 6 3/4 in., graphite on mylar",
        link: "paperpool4",
        privateCollection: "Private Collection"
    },
    {   
        name: lunge,
        artistName: "Lorraine Shemesh",
        title: "Lunge",
        year: "2013",
        dimensions: "29 1/2 x 23 in., graphite wash on mylar",
        link: "paperpool5",
        privateCollection: ""
    },
    {
        name: totem,
        artistName: "Lorraine Shemesh",
        title: "Totem",
        year: "2014",
        dimensions: "32 3/4 x 22 in., graphite wash on mylar",
        link: "paperpool6",
        privateCollection: "Private Collection"
    },
    {
        name: totemDetail1,
        artistName: "Lorraine Shemesh",
        title: "Totem- detail",
        year: "2014",
        dimensions: "32 3/4 x 22 in., graphite wash on mylar",
        link: "paperpool7",
        privateCollection: "Private Collection"
    },
    {
        name: tetheredLith,
        artistName: "Lorraine Shemesh",
        title: "Tethered",
        year: "2016",
        dimensions: "20 x 22 1/2 in., 2 color lithograph",
        link: "paperpool8",
        privateCollection: ""
    },
    {    
        name: loop,
        artistName: "Lorraine Shemesh",
        title: "Loop",
        year: "1999-2005",
        dimensions: "24 1/2 x 37 1/2 in., graphite wash on mylar",
        link: "paperpool11",
        privateCollection: "Private Collection"
    },
    {
        name: loopDetail1,
        artistName: "Lorraine Shemesh",
        title: "Loop - detail",
        year: "1999-2005",
        dimensions: "24 1/2 x 37 1/2 in., graphite wash on mylar",
        link: "paperpool12",
        privateCollection: "Private Collection"
    },
    {
        name: echoII,
        artistName: "Lorraine Shemesh",
        title: "Echo II",
        year: "2005",
        dimensions: "27 1/2 x 28 in., graphite wash on mylar",
        link: "paperpool13",
        privateCollection: ""
    },
    {
        name: amoeba,
        artistName: "Lorraine Shemesh",
        title: "Amoeba",
        year: "2005",
        dimensions: "31 1/2 x 26 1/2 in., graphite wash on mylar",
        link: "paperpool14",
        privateCollection: "Collection of Marie-Josee Kravis, President Emeritus, MOMA"
    },
    {
        name: amoebaDetail1,
        artistName: "Lorraine Shemesh",
        title: "Amoeba- detail",
        year: "2005",
        dimensions: "31 1/2 x 26 1/2 in., graphite wash on mylar",
        link: "paperpool15",
        privateCollection: "Collection of Marie-Josee Kravis, President Emeritus, MOMA"
    },
    {
        name: lasso,
        artistName: "Lorraine Shemesh",
        title: "Lasso",
        year: "2000",
        dimensions: "32 x 21 1/4 in., graphite wash on mylar",
        link: "paperpool16",
        privateCollection: ""
    },
    {
        name: lassoGld,
        artistName: "Lorraine Shemesh", 
        title: "Lasso",
        year: "2000",
        dimensions: "16 x 10 1/2 in., graphite on mylar",
        link: "paperpool17",
        privateCollection: ""
    },
    {
        name: ellipse,
        artistName: "Lorraine Shemesh",
        title: "Ellipse",
        year: "1998-2004",
        dimensions: "32 x 18 in., graphite wash on mylar",
        link: "paperpool18",
        privateCollection: "Private Collection"
    },
    {
        name: ellipseDetail1,
        artistName: "Lorraine Shemesh", 
        title: "Ellipse - detail",
        year: "1998-2004",
        dimensions: "32 x 18 in., graphite wash on mylar",
        link: "paperpool19",
        privateCollection: "Private Collection"
    },
    {
        name: wings,
        artistName: "Lorraine Shemesh",
        title: "Wings",
        year: "2008",
        dimensions: "26 3/4 x 25 1/2 in., graphite wash on mylar",
        link: "paperpool20",
        privateCollection: ""
    },
    {
        name: ring,
        artistName: "Lorraine Shemesh",
        title: "Ring",
        year: "1997-2004",
        dimensions: "33 1/2 x 25 1/2 in., graphite wash on mylar",
        link: "paperpool21",
        privateCollection: "Private Collection"
    },
    {
        name: link,
        artistName: "Lorraine Shemesh",
        title: "Link",
        year: "1999",
        dimensions: "21 3/4 x 21 3/4 in., graphite wash on mylar",
        link: "paperpool22",
        privateCollection: "Collection of The Butler Institute of American Art"
    },
    {
        name: precipice,
        artistName: "Lorraine Shemesh",
        title: "Precipice",
        year: "2017",
        dimensions: "30 1/4 x 22 in., graphite wash on mylar",
        link: "paperpool23",
        privateCollection: ""
    },
    {
        name: suspension,
        artistName: "Lorraine Shemesh",
        title: "Suspension",
        year: "2013",
        dimensions: "28 1/2 x 23 in., graphite wash on mylar",
        link: "paperpool24",
        privateCollection: ""
    },
    {
        name: crescent,
        artistName: "Lorraine Shemesh",
        title: "Crescent",
        year: "2013",
        dimensions: "35 x 22 3/4 in., graphite wash on mylar",
        link: "paperpool25",
        privateCollection: ""
    }]      
]
